import FetchUtils from '../utils/fetch.utils';

export default class TransactionService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_TRANSACTIONS}/api/movements`;

  static get = async (cardUid, organizationCode, page) => {
    const query = FetchUtils.getQueryParams({
      cardUid,
      organizationCode,
      page,
    });

    return await FetchUtils.get(TransactionService.BASE_URL + query, {
      headers: FetchUtils.getHeaders(),
    });
  };
}
